// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"VerificacionTable_spinnerContainer__vr7zO","botonAdd":"VerificacionTable_botonAdd__76IDP"};